import {SfCareerApi} from '../../shared/sdk/services/custom';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {SunfishApi} from '../../shared/sdk/index';
import {ShiftscheduleBloc} from "../../bloc/hr/shift/shiftschedule.bloc";
import { CareerBloc } from '../../bloc/feature/career/career.bloc';

@Injectable()

export class EmpInfoService {

  constructor(
    public sunfishApi: SunfishApi,
    public SfCareerApi: SfCareerApi,
    private shiftscheduleBloc: ShiftscheduleBloc,
    private careerBloc: CareerBloc
  ) {
  }

  viewGoEmp(empId): Observable<any> {

    return Observable.create((observer) => {

      this.shiftscheduleBloc.getEmp({empId: empId}).subscribe(
        result => {
          observer.next(result);
          observer.complete();
        }
        , error => {
          observer.next(error);
          observer.complete();
        }
      );
    });
  }

  getAllEmployeesName(): Observable<any> {

    return Observable.create((observer) => {
      this.careerBloc.getEmpObserver({empId: null}).subscribe(
        result => {
          observer.next(result);
          observer.complete();
        }
        , error => {
          observer.next(error);
          observer.complete();
        }
      );
    })
  }

  getEmployeeName(empId: any): Observable<any> {

    return Observable.create((observer) => {

      this.careerBloc.getEmpObserver({empId: empId}).subscribe(
        result => {
          observer.next(result);
          observer.complete();
        }
        , error => {
          observer.next(error);
          observer.complete();
        }
      );
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/emp-info.service/emp-info.service.ts